"use client";

import { useTravelerHomePage } from "@/providers/strapi/content/types/singleTypes/traveler-home-page";
import * as X from "@/ui";
import ReactMarkdown from "react-markdown";


// const data = {
//   title: {
//     en: <>Best VAT <strong className="font-medium">refund rates on the market</strong></>,
//     fr: <>Les meilleurs <strong className="font-medium">taux de remboursement du marché</strong></>,
//   },
//   text: {
//     en: "Unlock the highest possible refund with our progressive tier system. The more you spend, the more you get back. With Zapptax, get up to 90% of your VAT refunded, one of the best rates on the market.",
//     fr: "Bénéficiez d'un remboursement maximal grâce à notre système de paliers progressifs. Plus vous dépensez, plus vous récupérez. Avec Zapptax, récupérez jusqu'à 90 % de la TVA, l'un des meilleurs taux du marché.",
//   },
//   ofVat: {
//     en: "of the VAT",
//     fr: "de la TVA",
//   },
//   cta: {
//     en: "Download the app",
//     fr: "Téléchargez l'application",
//   },
// };


export function BestRatesSection(props: X.PageProps) {
  const { ref, inView } = X.useInViewObserver();

  const [progress, setProgressInt] = X.useState<number>(0);
  const progressRef = X.useRef<number>(0)
  const setProgress = (progress: number) => {
    setProgressInt(progress);
    progressRef.current = progress;
  };

  const duration = 2000;
  const end = 90;

  X.useEffect([inView], () => {
    if (!inView || progressRef.current > 0) {
      return;
    }

    const delay = duration / end;
    const interval = setInterval(() => {
      if (progressRef.current >= end) {
        return;
      }

      setProgress(progressRef.current + 1);

      if (progressRef.current >= end) {
        clearInterval(interval);
      }
    }, delay);
  });

  return (
    <section className="xl:mb-20 xl:pt-20" ref={ref}>
      <MobileCard locale={props.locale} progress={progress} />
      <DesktopCard locale={props.locale} progress={progress} />
    </section>
  );
}


function MobileCard(props: X.PageProps<{
  progress: number;
}>) {
  // const tr = X.useTranslator();
  const downloadUrl = X.useDownloadUrl(props.locale);
  const content = useTravelerHomePage('refundRateComponent')
  return (
    <div className={X.clsx(
      X.mobileOnly(),
      "pl-mobile-margin pr-mobile-margin-half mr-mobile-margin-half",
      "bg-surface-blue rounded-tr-4xl pt-10 pb-8 flex flex-col gap-2",
    )}>
      <h3 className="text-[36px] leading-tight">
        {/* {tr(data.title)} */}
        <ReactMarkdown components={{
          strong: ({ ...props }) => <strong {...props} className="font-medium" />,
        }}>
          {content.title}
        </ReactMarkdown>
      </h3>

      <div className="flex flex-row items-end justify-start -translate-x-[12px]">
        <div className="flex flex-row items-end">
          <div className="text-[155px] leading-[160px]">{props.progress}</div>
          <div className="text-[65px] leading-[105px] font-medium">%</div>
        </div>
        <div className="text-[16px] leading-[70px] font-medium text-nowrap pl-[4px]">
          {/* {tr(data.ofVat)} */}
          <ReactMarkdown>
            {content.rateHint}
          </ReactMarkdown>
        </div>
      </div>

      {/* <p className="text-[16px] leading-tight mb-4">
        {tr(data.text)}
        {content.message}
      </p> */}
      <ReactMarkdown components={{
        p: ({ ...props }) => <p {...props} className="text-[16px] leading-tight mb-4" />
      }}>
        {content.message}
      </ReactMarkdown>
      <div>
        <X.Button
          primary
          exitHref={downloadUrl}
          // label={tr(data.cta)}
          label={content.cta}
          lg
        />
      </div>
    </div>
  );
}


function DesktopCard(props: X.PageProps<{
  progress: number;
}>) {
  // const tr = X.useTranslator();
  const content = useTravelerHomePage('refundRateComponent')
  return (
    <div className={X.clsx(
      X.desktopOnly("flex"),
      "max-w-content bg-surface-blue rounded-4xl p-10 mx-auto items-center gap-10",
    )}>
      <div className="flex-1">
        <h3 className="text-[48px] mb-4 leading-tight">
          {/* {tr(data.title)} */}
          <ReactMarkdown components={{
            strong: ({ ...props }) => <strong {...props} className="font-medium" />,
          }}>
            {content.title}
          </ReactMarkdown>
        </h3>
        {/* <p className="text-[20px]">
          {tr(data.text)}
          {content.message}
        </p> */}
        <ReactMarkdown components={{
          p: ({ ...props }) => <p {...props} className="text-[20px]" />
        }}>
          {content.message}
        </ReactMarkdown>
      </div>

      <div className="w-[30%] flex-initial leading-none flex flex-col items-end">
        <div className="text-[180px] font-light flex flex-row items-end">
          {props.progress}<span className="text-[80px] leading-[120px] align-top">%</span>
        </div>
        <div className="text-right text-[20px] font-semibold">
          {/* {tr(data.ofVat)} */}
          <ReactMarkdown>
            {content.rateHint}
          </ReactMarkdown>
        </div>
      </div>
    </div>
  );
}
